<template>
  <div class="page-container div-body">
    <div class="page-header">
      <br />
      <span class="titulo" style="margin-top: -30px; color: #ffff">Un Ray</span>

      <div class="container">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="page-caption">
              <div class="div-caption">
                  <h1 class="page-title">¡Llena tu  solicitud hoy!</h1>
              <h3 class="page-subtitle">Forma parte del equipo Ray</h3>
              </div>
            
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-section">
      <div class="container">
        <div
          class="card-block bg-white"
          style="border-radius: 10px; padding: 1px; background: #ffff"
        >
        
          <Mdsteppers/>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <mdb-footer
      color="indigo"
      class="font-small pt-0"
      style="margin-bottom: 0px"
    >
      <mdb-container>
        <mdb-row>
          <mdb-col md="12" style="text-align: center">
            <div class="mb-5 flex-center">
              <a
                href="https://www.facebook.com/Un-Ray-Guatemala-102275728863648"
                class="fb-ic"
                ><i class="fab fa-facebook fa-lg white-text mr-md-5 mr-3 fa-2x">
                </i
              ></a>
              <div class="footer-copyright text-center py-3">
                <mdb-container fluid>
                  &copy; {{ new Date().getFullYear() }} - Un Ray Guatemala
                </mdb-container>
              </div>
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </mdb-footer>
    <!-- Footer -->
  </div>
</template>
<script>
import navbarAfilia from "../components/navbarAfilia.vue";

import Mdsteppers from "../components/Mdsteppers.vue"

import { mdbFooter, mdbContainer, mdbRow, mdbCol } from "mdbvue";



export default {
  components: {
    navbarAfilia,
  
    mdbFooter,
    mdbContainer,
    mdbRow,
    mdbCol,
    Mdsteppers
  }, //src="../assets/terminos_condiciones.pdf"

  name: "afiliacionRay",
  data() {
    return {
      
    }
  },
  methods: {
    

  },

  mounted() {
    // this.$router.replace("/").catch(() => {});
  },
  beforeDestroy() {
    // this.$router.replace("/").catch(() => {});
  },
};
</script>

<style  scoped>


/* dadaldkfñal */

body {
  margin-top: 20px;
  color: #1a202c;
  text-align: left;
  background-color: #e2e8f0;
}
.main-body {
  padding: 15px;
}
.card {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1rem;
}

.gutters-sm {
  margin-right: -8px;
  margin-left: -8px;
}

.gutters-sm > .col,
.gutters-sm > [class*="col-"] {
  padding-right: 8px;
  padding-left: 8px;
}
.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.bg-gray-300 {
  background-color: #e2e8f0;
}
.h-100 {
  height: 100% !important;
}
.shadow-none {
  box-shadow: none !important;
}

.btn-bajar {
  z-index: 2;
  position: fixed;
  bottom: 10%;
}

.div-h {
  height: 200px;
}

.vendor_logo_hide {
  display: inline !important;
  color: transparent;
  width: 99px;
}

.vendor_logo {
  display: block !important;
  color: black;
  width: 100%;
}

.btn-confirmarSpinner {
  color: orangered;
  border-radius: 8px;
  font-weight: bolder;
}

.conta-content {
}
.titulo {
  margin-top: 40px;
  font-family: "Rachell", Helvetica, Arial;
  font-size: 35px;
  text-shadow: 2px 2px 2px rgb(48, 48, 48);
  z-index: 2;
  color: #ffff;
  margin-left: 10px;
}

.portada {
  background: url(../assets/portada.jpg) no-repeat;
  position: relative;
  background-size: cover;
}

.md-app-d {
  border-radius: 8px;
}

.md-content {
  margin-top: 10px;
  padding-left: -5px;
}

.md-til {
}

.div-message {
  height: auto;
  margin-bottom: 90px;
  font-weight: bolder;
  background: rgba(155, 155, 155, 0.6);
  padding: 3px;
  border-radius: 5px;
}

.message {
  font-weight: bolder;
  font-size: 15px;
}

/* */
/**/
.p-titulo {
  color: #ffff;
  font-family: "Rachell", Helvetica, Arial;
  font-weight: bolder;
  font-size: 74px;
  margin-bottom: 0px;
}

.p-mensaje {
  font-family: Helvetica, Arial;
  color: #ffff;
  padding: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.div-titulo {
  margin-left: 10px;
  margin-top: -75%;
}

/** */

body {
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-family: "Overpass", sans-serif;
  letter-spacing: 0px;
  font-size: 17px;
  color: #8d8f90;
  font-weight: 400;
  line-height: 32px;
  background-color: #edefef;
}

ul,
ol {
}
a {
  text-decoration: none;
  color: #8d8f90;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}
a:focus,
a:hover {
  text-decoration: none;
  color: #f85759;
}

.page-header {
  background: url(../assets/portada.jpg) no-repeat;
  position: relative;
  background-size: cover;
}

.page-headers {
  background: url(../assets/portada.jpg) no-repeat;
  position: relative;
  background-size: cover;
}
.page-caption {
  padding-top: 15px;
  padding-bottom: 120px;
  padding-left: -3px;

}
.div-caption{
   background: rgba(44, 48, 44, 0.5);
  width: 205px;
  border-radius: 8px;
}
.page-title {
  font-size: 28px;
  line-height: 1;
  margin-top: 5px;
  color: #fff;
  font-weight: bolder;
  text-align: left;
  font-family: "Rachell", Helvetica, Arial;

  padding: 5px;
 
  margin-bottom: -0.513px;
}
.page-subtitle {
  margin-top: 0px;
  font-size: 13px;
  text-align: left;
  color: #fff;
  font-weight: bolder;
 
  padding: 5px;
}
.card-section {
  padding: 0px;
  position: relative;
  bottom: 90px;
  border-radius: 10px;
  background: transparent !important;
}
.card-block {
  padding: 80px;
}
.section-title {
  margin-bottom: 60px;
}

.page-servicios {
  text-align: center;
  font-weight: bolder;
  margin-top: 5px;
  margin-bottom: 16px;
}

.row-div {
  border-radius: 8px;
}

.div-body {
  background: rgb(235, 235, 235);
}

.div-descargar {
  position: absolute;
  right: 8px;
  top: 8px;
  height: 40px;
}

.card-div {
  color: rgb(97, 97, 97);
  border: none !important;
}

.box:hover {
  background: rgb(0, 172, 0); /* make this whatever you want */
}

.wrapper {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  -moz-overflow-scrolling: touch;
  -ms-overflow-scrolling: touch;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid orangered;
  display: inline-block;
  color: orangered;
  font-weight: bolder;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 8px;
}

.custom-file-upload:hover {
  background: orangered;
  color: #fff;
}

.md-step {
}
</style>


// WEBPACK FOOTER //
// src/components/afiliacionRay.vue